<template>
  <app-modalData :init = "metaData"  @f="f($event)"  v-if="metaData">

  </app-modalData>
</template>




<script>
import axios from 'axios'
export default {
props: ['results'],
 data: function(){
  return {
    modalData:{
     sb: {
       snackbar: false,
       color: 'success',
       text: ''
     },
     f: "",
     selectedItem: "in",
       header:{
         text:"",
          icon:"mdi-database",
         icons:[
           {
             name:"mdi-close",
             f:"close",
           },
         ]
       },
     bar: {
         items:[
           {
              itemName: 'in',
              text:'Результат процесса',
              f: null,
           },


         ],
         status: ""
       },
     content:{
       type:'pages',
         items:{

             in:{
               foundData:  {

                          },
               meneger:{

                       },
             },


         },
       },


     operations:{

     }

    },
  }
},

methods: {

  f(fName){
  eval('this.'+fName+'()')
  },



close(){
  this.results.modal = false
  this.results.contentType = ''
  this.results.foundData.selector = false
  this.results.foundData.foundIds = []
  this.results.foundData.displayIds = []
  this.results.foundData.selectedIds = []
  this.results.foundData.offset = 0
  this.results.foundData.selectAll = false
},

},
beforeUpdate(){

},

computed: {
  metaData(){
    if(this.results.modal){
     this.modalData.header.text = this.results.procInfo.title
     this.modalData.content.type = this.results.pagesContentMenegment.contentInfo.type


      this.modalData.content.items.in.meneger =   this.results.pagesContentMenegment
      this.modalData.content.items.in.foundData =   this.results.foundData

      return this.modalData
    } else return false
    },
},




}
</script>

<style  >

</style>
